import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATED,
  SEAT_LIST,
  LOADER_FALSE,
  LOADER_CHECK,
  ROOM_LIST,
  ROOM_PHONE_DATA,
  ROOM_ALL_GRAPH,
} from '../type';
import axios from 'axios';
import axiosInstance from '../../utils/axiosInstance';
import { toast } from 'react-toastify';
import {
  RoomBookingList,
  GetList,
  RoomBookingAllGraphs,
} from '../../Component/Helpers/api';
import $ from 'jquery';


export const RoomBookingData = (pageDetail) => async (dispatch) => {
  dispatch({ type: LOADING_UI });

  try {
    const organizationData = JSON.parse(localStorage.getItem('headData'));

    if (!organizationData) {
      toast.error('Organization data not found in local storage.');
      return;
    }

    const res = await axiosInstance.post(
      `${process.env.REACT_APP_API_GATEWAYS_URL}meeting-room/api/booking/list`,
      pageDetail,
      {
        headers: {
          'req-organization-id': organizationData.organizationId,
   
        },
      }
    );

    if (res.status === 200) {
      dispatch({ type: ROOM_LIST, payload: res });
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: LOADER_CHECK });

      // If using React state modal
      // handleCloseBooking();  ❌ Avoid $(".close").click()

    } else {
      dispatch({ type: CLEAR_ERRORS });
      toast.error(res.data.message || "Something went wrong!");
    }

  } catch (error) {
    console.error("API Error:", error);
    dispatch({ type: CLEAR_ERRORS });

    if (error.response) {
      const { status, data } = error.response;

      if (status === 400) {
        toast.error(data?.message || "Bad Request: Invalid input!");
      } else {
        toast.error(data?.message || "An error occurred while fetching data.");
      }
    } else {
      toast.error("Network error. Please try again.");
    }
  }
};

export const RoomPhoneData = param => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));

  dispatch({ type: LOADING_UI });
  axios
    .post(GetList.data, param, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: ROOM_PHONE_DATA, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        $('.close').click();
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {});
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const graphAllData = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  dispatch({ type: LOADING_UI });
  axios
    .post(RoomBookingAllGraphs.data, pageDetail, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: ROOM_ALL_GRAPH, payload: res });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        $('.close').click();
        if (!res.data.status_message == '') {
          toast.success(res.data.status_message, {});
        }
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.status_message, {});
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const CheckLoader = () => dispatch => {
  dispatch({ type: LOADER_FALSE });
};
